import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { XaraLogo as Icon } from 'theme/icons';

const styles = theme => ({
	root: {
		position: 'absolute',
		left: 20,
		bottom: 15,
		width: 70,
		height: 25,
		color: theme.palette.colors.alpha,
		zIndex: theme.zIndex.xaraLogo
	}
});

const XaraLogo = props => <Icon className={props.classes.root} />;

XaraLogo.propTypes = {
	classes: PropTypes.object
};

export default withStyles(styles)(XaraLogo);



// WEBPACK FOOTER //
// ./src/components/XaraLogo/XaraLogo.js